<template>
    <div class="row">
        <div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="fxsymbolprice == 0? 'active': ''" v-on:click.prevent="fxsymbolprice = 0"><a href="#">{{$t('db_requestBon')}}</a></li>
                <li :class="fxsymbolprice == 1? 'active': ''" v-on:click.prevent="fxsymbolprice = 1"><a href="#">{{$t('db_removeBon')}}</a></li>
                <li :class="fxsymbolprice == 2? 'active': ''" v-on:click.prevent="fxsymbolprice = 2"><a href="#">{{$t('db_bonusList')}}</a></li>
            </ul>
        </div>
        <div class="col-12" v-if="fxsymbolprice == 0">
           <div class="row justify-content-center no-gutter">
               <div class="middleBox ">
                   <RequestBonus></RequestBonus>
               </div>
           </div>
        </div>
        <div class="col-12"  v-if="fxsymbolprice == 1">
            <div class="row justify-content-center no-gutter">
               <div class="middleBox ">
                   <RemoveBonus></RemoveBonus>
               </div>
           </div>
          
        </div>
        <div class="col-12" v-if="fxsymbolprice == 2">
            <BonusList></BonusList>
        </div>
    </div>
</template>
<script>
    import RequestBonus from './pages/request_bonus'
    import RemoveBonus from './pages/remove_bonus'
    import BonusList from './pages/bonus_list'
    export default {
        name: 'Deposit-bonus',
        data() {
            return {               
                fxsymbolprice : '0',
            }
        },
        components:{
            RequestBonus : RequestBonus,
            RemoveBonus : RemoveBonus,
            BonusList : BonusList,
        },
        created(){
            if(this.$route.query.tab == 'list'){
                this.fxsymbolprice = 2
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bonus/deposit_bonus.vue